import { render, staticRenderFns } from "./add-file-dialog.vue?vue&type=template&id=286e18e8"
import script from "./add-file-dialog.vue?vue&type=script&lang=js"
export * from "./add-file-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-file-dialog.vue?vue&type=style&index=0&id=286e18e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports